import el from './el.json';
import en from './en.json';

export const propertyResources = {
  en,
  el,
};
